import {useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import {Dropdown1} from '../../../../../../_metronic/partials'
import {useListView} from '../core/ListViewProvider'
import {sendChat} from '../core/_requests'
import {jsPDF} from 'jspdf'

import {PDFDownloadLink, Page, Text, View, Document, StyleSheet, Image} from '@react-pdf/renderer'
import { useAuth } from '../../../../auth'
import { useCompanies } from '../../../../auth/core/Companies'
const UserEditModalHeader = () => {
  const {setItemIdForUpdate} = useListView()
  const [exportPdfLoading, setExportPdfLoading] = useState(false)
  const [emailTranscriptLoading, setEmailTranscriptLoading] = useState(false)
  const {currentUser} = useAuth();
  const chatListContext = useListView()
  const {defaultCompany} = useCompanies();

  const handleExportPDF = async () => {
    // Disable the export button while the PDF is being generated
    setExportPdfLoading(true)

    // Create a new PDF document
    const doc = new jsPDF('p', 'pt', 'a4')
    // Define the font size and line height factor
    const fontSize = 10
    doc.setLineHeightFactor(1.2)
    // Set the page dimensions and padding
    const pageWidth = doc.internal.pageSize.getWidth()
    const pageHeight = doc.internal.pageSize.getHeight()
    const paddingLeft = 20
    const paddingRight = 20
    const usableWidth = pageWidth - paddingLeft - paddingRight
    const usableHeight = pageHeight

    chatListContext.chat.messages?.forEach((message, index) => {
      const {sentBy, message: text} = message

      // Set the font size and line height factor
      doc.setFontSize(fontSize)
      const lines = doc.splitTextToSize(`${sentBy?.toUpperCase()}: ${text}`, usableWidth - 10, {
        maxWidth: usableWidth,
      })

      // Calculate the y position of the text based on the line height and index
      const lineHeight = doc.getLineHeight()
      let y = 20 + lineHeight * index

      // Add extra spacing if there is more than one line of text
      if (lines.length > 1) {
        y += (lines.length - 1) * fontSize + lineHeight / 2
      }

      // Add the text to the PDF document
      doc.text(lines, paddingLeft, y)
    })

    doc.save('AssistantChat.pdf')
    // Re-enable the export button
    setExportPdfLoading(false)
  }

  const DownloadPDF = ({messages}: any) => {
    return (
      <PDFDownloadLink document={<PdfDocument messages={messages} />} fileName='AssistantChat.pdf'>
        {({blob, url, loading, error}) => (loading ? 'Generating PDF...' : 'Download PDF')}
      </PDFDownloadLink>
    )
  }

  const handleEmailTranscript = async () => {
    setEmailTranscriptLoading(true)
    var emailSend = await sendChat(chatListContext.chat._id, currentUser?.email,defaultCompany?.company_id)
    setEmailTranscriptLoading(false)
  }
  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>Chat Details</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div className='ms-auto'>
        {' '}
        {/* add div with ms-auto class */}
        <button type='submit' className='btn btn-primary btn-sm me-2'>
          <KTSVG path='/media/svg/customicons/pdf.svg' className='svg-icon' />
          <PDFDownloadLink
            style={{color: 'white'}}
            document={<PdfDocument messages={chatListContext.chat.messages} />}
            fileName='AssistantChat.pdf'
          >
            {({blob, url, loading, error}) => (exportPdfLoading ? 'Exporting' : 'Export PDF')}
          </PDFDownloadLink>
        </button>
        <span style={{width: '10px'}}></span>
        <button
          type='submit'
          className='btn btn-primary btn-sm'
          disabled={emailTranscriptLoading}
          onClick={handleEmailTranscript}
        >
          <KTSVG path='/media/svg/customicons/email.svg' className='svg-icon' />
          {!emailTranscriptLoading && 'Email Transcript'}
          {emailTranscriptLoading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Sending... <span className='spinner-border spinner-border-sm ms-2'></span>
            </span>
          )}
        </button>
      </div>

      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() => {
          setItemIdForUpdate(undefined)
        }}
        style={{cursor: 'pointer'}}
      >
        <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {UserEditModalHeader}

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20,
  },
  logoContainer: {
    alignSelf: 'center',
    justifyContent: 'center',
    marginBottom: 10,
    height: 20,
  },
  logo: {
    flex: 1,
    alignSelf: 'center',
  },
  title: {
    fontSize: 15,
    fontWeight: 'bold',
    alignSelf: 'center',
    marginBottom: '30pt',
  },
  page: {
    flexDirection: 'column',
    backgroundColor: '#fff',
    padding: '30pt',
    marginLeft: '30pt',
    marginRight: '30pt',
  },

  message: {
    fontSize: 10,
    marginBottom: '5pt',
    lineHeight: 1,
  },
  sentBy: {
    fontWeight: 'bold',
    fontSize: 10,

  },
})
const PdfDocument = ({messages}: any) => {

  return (
    <Document>
      <Page size='A4' style={styles.page}>
        <View style={styles.logoContainer}>
          <Image src={toAbsoluteUrl('/media/logos/dokmee-logo.png')} style={styles.logo} />
        </View>
        <Text style={styles.title}>Chat Transcript</Text>

        <View>
          {messages.map(({sentBy, message}: any, index: any) => (
            
            <Text key={index} style={styles.message}>
              <Text style={styles.sentBy}>{`${sentBy?.toUpperCase()}: `}</Text>
              {convertToPlain(message)}{' '}
            </Text>
          ))}
        </View>
      </Page>
    </Document>
  )
}

function convertToPlain(html:any){

  // Create a new div element
  var tempDivElement = document.createElement("div");

  // Set the HTML content with the given value
  tempDivElement.innerHTML = html;

  // Retrieve the text property of the element 
  return tempDivElement.textContent || tempDivElement.innerText || "";
}
